<template>
  <div :class="['content-box', GET_STATUS ? 'collapse' : '']">
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["GET_STATUS"]),
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.content-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>
